import React from 'react'

function About() {
    return (
        <div>
            Hellooooooo!

        </div>
    )
}

export default About
